export default __webpack_public_path__ + "static/widgetImagephotoshop-22cc67776be7a7287894ee30d63923e3.gif";